module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/github-c1a20536282fc99178e66a711d2dc9fe.svg";